import { CareServiceEditDrawer } from '@app/icare/routes/_app/pflegedienste/-components/CareServiceEditDrawer'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { QueryBaseSchema } from '@pkg/api/query/QueryFilterSchema'
import { defineEntityConfig } from '@pkg/db/schema/EntityConfig'
import { ButtonLink } from '@pkg/ui/button'
import { LinkIndicatorIcon } from '@pkg/ui/common'
import { FormattedNameAndAddress } from '@pkg/ui/formattedContent/NameAndAddress'
import { FaTruckMedical } from 'react-icons/fa6'
import { z } from 'zod'
import { CareServiceSchema } from './schema/CareService'

const label = t`Pflegedienst`

export const CareServiceConfig = defineEntityConfig(() => ({
  schema: CareServiceSchema,

  label,
  labelPlural: t`Pflegedienste`,

  icon: FaTruckMedical,

  route: {
    list: '/pflegedienste',
    edit: '/pflegedienste/$id',
    new: '/pflegedienste/new',
  },

  drawer: { modal: CareServiceEditDrawer },

  relationSelectionColumns: [
    {
      key: 'careService.name',
      title: label,
      sorter: true,
      render: (_, row) => <FormattedNameAndAddress name={row.name} address={row.address ?? undefined} />,
    },
    {
      title: t`Versorgungsbereich`,
      key: 'careService.serviceArea',
      sorter: true,
      render: (_, record) => record.serviceArea,
    },
  ],

  indexColumns: [
    {
      key: 'careService.name',
      title: label,
      sorter: true,
      fixed: 'start',
      render: (_, row) => (
        <FormattedNameAndAddress
          name={row.name}
          address={row.address ?? undefined}
          link={{ to: '/pflegedienste/$id', params: { id: row.id } }}
        />
      ),
    },
    {
      title: t`Versorgungsbereich`,
      key: 'careService.serviceArea',
      sorter: true,
      render: (_, record) => record.serviceArea,
    },
    {
      key: 'actions',
      title: <Trans>Aktionen</Trans>,
      sorter: false,
      fixed: 'end',
      render: (_, row) => (
        <ButtonLink to="/pflegedienste/$id" params={{ id: row.id }} size="small" shape="round">
          <Trans>Anzeigen</Trans>
          <LinkIndicatorIcon />
        </ButtonLink>
      ),
    },
  ],

  search: {
    filterSchema: QueryBaseSchema.extend({
      sortBy: z
        .enum([
          'careService.name',
          'careService.address.streetAddress',
          'careService.address.zipCode',
          'careService.address.city',
          'careService.serviceArea',
        ])
        .nullish(),
    }),
    sortableFields: ['name', 'createdAt'] as const,
    defaultSortBy: 'name',
    defaultSortOrder: 'asc',
  },

  format: {
    primary: val => val?.name,
  },
}))
